import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import DeleteButton from '../utils/delete-button';

class UrlThumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { dimensions: {} };
    this.onImgLoad = this.onImgLoad.bind(this);
  }

  onImgLoad = ({ target: img }) => {
    this.setState({
      dimensions: {
        height: img.offsetHeight,
        width: img.offsetWidth,
      },
    });
  }
  handleSelect = () => {
    if (this.props.onSelect && this.props.file.viable) {
      this.props.onSelect(this.props.file);
    }
  }

  handleUnSelect = () => {
    if (this.props.onUnSelect && this.props.file.viable) {
      this.props.onUnSelect(this.props.file);
    }
  }

  render() {
    const url = ['thumb', 'thumb_url', 'url'].reduce(
      (memo, key) => memo || this.props.file[key],
      null
    );
    const imageCaption = this.props.file.filename ? this.props.file.filename : this.props.file.title;
    const { width, height } = this.state.dimensions;

    const actionButton = () => {
      if (this.props.onRemoveThumbnail)
        return (
          <DeleteButton
            handleDelete={() => this.props.onRemoveThumbnail(this.props.file)}
          />
        );

      if (this.props.selected)
        return (
          <span className="fa-stack fa-xs" onClick={this.handleUnSelect}>
            <i className="fas fa-square fa-stack-2x" />
            <i className="fas fa-check fa-stack-1x fa-inverse" />
          </span>
        );
    };
    return (
        <div
          className={classNames(
            'image-container',
            { selected: this.props.selected },
            { fadein: this.props.onRemoveThumbnail }
          )}>
          <button
            aria-label={this.props.file.title}
            aria-checked={this.props.selected}
            className={classNames('thumbnail_ url')}
            role={this.props.onRemoveThumbnail ? 'note' : 'checkbox'}
            style={{
              backgroundImage: !this.props.withOrientation && `url(${url})`,
            }}
            onClick={this.props.selected ? this.handleUnSelect : this.handleSelect}>
            {this.props.withOrientation && (
              <img src={url} onLoad={this.onImgLoad} alt={imageCaption} />
            )}
          </button>
          { this.props.displayCaption && <p style={{ width: width }} className="file-caption">
              {imageCaption}
            </p> }
          {actionButton()}
        </div>
    );
  }
}

UrlThumbnail.propTypes = {
  file: PropTypes.object.isRequired,
  onRemoveThumbnail: PropTypes.func,
  onSelect: PropTypes.func,
  onUnSelect: PropTypes.func,
  selected: PropTypes.bool,
  withOrientation: PropTypes.bool,
  displayCaption: PropTypes.bool
};

export default UrlThumbnail;
